import { Injectable } from '@angular/core'
import { ProgressService } from '@mmx/components'
import {
  debounceTime,
  finalize,
  Observable,
  shareReplay,
  startWith,
  Subject,
  switchMap,
  tap,
} from 'rxjs'

import {
  INSURANCE_PROVIDER_SOURCE,
  INSURANCE_PROVIDER_TRANSACTION_TYPE,
} from '../model/insurance-provider'
import { InsuranceProviderLookup } from '../model/insurance-provider-lookup'
import { CrudService } from './crud.service'

@Injectable({
  providedIn: 'root',
})
export class InsuranceProviderLookupsService {
  public loading$ = this.progressService.progress$
  public refresh$ = new Subject<void>()

  public all$ = this.refresh$.pipe(
    startWith(null),
    debounceTime(100),
    tap(() => this.progressService.start('all')),
    switchMap(() =>
      this.crudService
        .index(InsuranceProviderLookup)
        .pipe(finalize(() => this.progressService.stop('all'))),
    ),
    // map(fields => orderBy(fields, 'name')),
    shareReplay(1),
  )

  public connected$ = this.refresh$.pipe(
    startWith(null),
    debounceTime(100),
    tap(() => this.progressService.start('connected')),
    switchMap(() =>
      this.crudService
        .index(InsuranceProviderLookup, { connected: true })
        .pipe(finalize(() => this.progressService.stop('connected'))),
    ),
    // map(fields => orderBy(fields, 'name')),
    shareReplay(1),
  )

  public get(lookupId: string): Observable<InsuranceProviderLookup> {
    return this.crudService.read(InsuranceProviderLookup, lookupId)
  }

  public doesLookupSupport(
    lookup: InsuranceProviderLookup,
    transaction: INSURANCE_PROVIDER_TRANSACTION_TYPE,
  ): boolean {
    return (
      lookup?.provider?.source === INSURANCE_PROVIDER_SOURCE.AVAILITY &&
      lookup?.provider?.supportedTransactions?.includes(transaction)
    )
  }

  constructor(
    private crudService: CrudService,
    private progressService: ProgressService<'all' | 'connected'>,
  ) {}
}
